import React, { useState } from "react";
import * as Sentry from "@sentry/react";
import { useNavigate, useParams } from "react-router";
import { useDispatch } from "react-redux";
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { changePassword } from "../../store/actions/forgotPasswordActions";

function ResetPassword() {
  // status is password changed or not
  const [status, setStatus] = useState(false);
  // state to display errors
  const [error, seterror] = useState("");
  // code from Params
  const { email } = useParams();
  //history for routing
  const history = useNavigate();
  // dispatch actions
  const dispatch = useDispatch();
  //oldPassword
  const [oldPassword, setoldPassword] = useState("");
  //password
  const [password, setpassword] = useState("");
  const [passwordStrength, setpasswordStrength] = useState(0);
  //confirmPass
  const [confirmPassword, setconfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState("password");
  const [showPassword, setShowPassword] = useState("password");
  const [showConfirmPassword, setShowConfirmPassword] = useState("password");
  // check password strength
  const handleSetPassword = (e) => {
    try {
      let strengthLevel = 0;
      const passArray = [...e];
      setpassword(e);
      if (e !== 0) {
        const hasLowerCase = passArray?.filter(
          (letter) => letter >= "a" && letter <= "z"
        );
        const hasUpperCase = passArray?.filter(
          (letter) => letter >= "A" && letter <= "Z"
        );
        const hasNumber = passArray?.filter(
          (letter) => letter >= "0" && letter <= "9"
        );
        const hasSC1 = passArray?.filter(
          (letter) => letter >= "!" && letter <= "/"
        );
        const hasSC2 = passArray?.filter(
          (letter) => letter >= ":" && letter <= "@"
        );
        const hasSC3 = passArray?.filter(
          (letter) => letter >= "[" && letter <= "`"
        );
        const hasSC4 = passArray?.filter(
          (letter) => letter >= "{" && letter <= "~"
        );
        if (hasLowerCase?.length > 0) {
          strengthLevel = strengthLevel + 20;
        }
        if (hasUpperCase?.length > 0) {
          strengthLevel = strengthLevel + 20;
        }
        if (hasNumber?.length > 0) {
          strengthLevel = strengthLevel + 20;
        }
        if (
          hasSC1?.length > 0 ||
          hasSC2?.length > 0 ||
          hasSC3?.length > 0 ||
          hasSC4?.length > 0
        ) {
          strengthLevel = strengthLevel + 20;
        }
        if (e?.length > 5) {
          strengthLevel = strengthLevel + 20;
        }
      }
      setpasswordStrength(strengthLevel);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

  const handleResetPassword = () => {
    try {
      if (oldPassword && password && confirmPassword) {
        if (passwordStrength === 100) {
          if (password === confirmPassword) {
            const resetPasswordData = {
              currentPassword: oldPassword,
              newPassword: password,
              email: email,
            };
            console.log(
              "new pass data from reset pass component",
              resetPasswordData
            );
            setLoading(true);
            dispatch(
              changePassword(
                resetPasswordData,
                history,
                setStatus,
                seterror,
                setLoading
              )
            );
          } else {
            alert("Passwords do not match");
          }
        } else {
          alert(
            "Your password must contain at least 6 characters. It should include a mix of upper and lower case letters, numbers, and special characters."
          );
        }
      } else {
        alert("Please fill all the fields");
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

  return (
    <div
      className="flex items-start justify-center px-4 w-full pt-6"
      style={{ minHeight: "calc(100vh - 60px)" }}
    >
      <div className="w-full max-w-container mx-auto">
        {status ? (
          <div className="text-center pt-8">
            <div className="text-[#211F59] text-2xl font-semibold mb-2">
              Password Changed Successfully!
            </div>
            <div
              className="text-[#7876A1] text-sm font-semibold underline cursor-pointer"
              onClick={() => history("/Login")}
            >
              Back to Sign in
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="flex flex-col items-start gap-1 mb-2">
              <h1 className="text-[#211F59] text-2xl font-semibold">
                Change Password
              </h1>
              <p className="text-[#211F59] text-sm font-semibold">
                Set a new secure password for your account.
              </p>
            </div>

            <div className="relative">
              <input
                placeholder="Old password"
                value={oldPassword}
                type={showOldPassword}
                className="w-full bg-[#E6E6E6] placeholder-[#89839B] text-[#373559] pl-[13.5px] pr-12 h-[48px] rounded-[12px] text-sm outline-none border-[1px] border-transparent focus:border-[#7876A1]"
                onChange={(e) => setoldPassword(e?.target?.value)}
              />
              <button
                onClick={() =>
                  setShowOldPassword((prev) =>
                    prev === "password" ? "text" : "password"
                  )
                }
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#5B5472]"
                aria-label="toggle old password visibility"
                type="button"
              >
                {showOldPassword === "password" ? (
                  <BsFillEyeFill size={18} />
                ) : (
                  <BsFillEyeSlashFill size={18} />
                )}
              </button>
            </div>

            <div className="relative">
              <input
                placeholder="Password"
                value={password}
                type={showPassword}
                className="w-full bg-[#E6E6E6] placeholder-[#89839B] text-[#373559] pl-[13.5px] pr-12 h-[48px] rounded-[12px] text-sm outline-none border-[1px] border-transparent focus:border-[#7876A1]"
                onChange={(e) => handleSetPassword(e?.target?.value)}
              />
              <button
                onClick={() =>
                  setShowPassword((prev) =>
                    prev === "password" ? "text" : "password"
                  )
                }
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#5B5472]"
                aria-label="toggle password visibility"
                type="button"
              >
                {showPassword === "password" ? (
                  <BsFillEyeFill size={18} />
                ) : (
                  <BsFillEyeSlashFill size={18} />
                )}
              </button>
            </div>

            <div className="relative">
              <input
                placeholder="Confirm password"
                value={confirmPassword}
                type={showConfirmPassword}
                className="w-full bg-[#E6E6E6] placeholder-[#89839B] text-[#373559] pl-[13.5px] pr-12 h-[48px] rounded-[12px] text-sm outline-none border-[1px] border-transparent focus:border-[#7876A1]"
                onChange={(e) => setconfirmPassword(e?.target?.value)}
              />
              <button
                onClick={() =>
                  setShowConfirmPassword((prev) =>
                    prev === "password" ? "text" : "password"
                  )
                }
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#5B5472]"
                aria-label="toggle confirm password visibility"
                type="button"
              >
                {showConfirmPassword === "password" ? (
                  <BsFillEyeFill size={18} />
                ) : (
                  <BsFillEyeSlashFill size={18} />
                )}
              </button>
            </div>

            <div style={{ color: "red" }}>{error ? error : ""}</div>

            <button
              onClick={handleResetPassword}
              disabled={loading}
              aria-busy={loading}
              className="w-full mt-[10px] bg-[#34318C] text-white rounded-[15px] px-8 h-[48px] text-sm font-medium hover:opacity-95 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center"
            >
              {loading ? (
                <Box sx={{ display: "flex" }}>
                  <CircularProgress size={18} color="inherit" />
                </Box>
              ) : (
                "Change Password"
              )}
            </button>

            <div className="text-center w-full text-[12px] text-[#211F59] mt-[3px]">
              Remember your password?{" "}
              <span
                className="text-[#211F59] font-bold cursor-pointer underline"
                onClick={() => history("/Login")}
              >
                Sign in
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
